module.exports = __webpack_public_path__ + "static/gm-9-c56df47e2d57653b8cdb8879b7e65e14.jpg";